import './PermissionProvider.scss';
import * as constants from '../../utils/constants/constant';
import { isAuthenticate } from '../../utils/helpers/helpers';
import { useHistory } from 'react-router-dom';

const PermissionProvider = (props) => {
  const { needAuthor, grantPermision, children } = props;
  const loggedIn = isAuthenticate();
  const history = useHistory();
  if (
    window.location.pathname !== constants.routes.HOME &&
    needAuthor &&
    !loggedIn
  ) {
    history.push(constants.routes.HOME);
    return '';
  }
  return children;
};

export default PermissionProvider;
